export default "__VITE_ASSET__B3_IP7li__"